import { render } from "./Loading.vue?vue&type=template&id=ff2f3a8a"
import script from "./Loading.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Loading.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script